import { sprintf } from 'sprintf-js';

import { S3Picker } from 'containers/S3Picker';

import { ContentLarge } from './ContentLarge';
import { ContentSmall } from './ContentSmall';
import {
  DropContainer,
  HoverOverlayLarge,
  HoverOverlaySmall,
} from './FilePicker.styled';
import type { FilePickerProps } from './types';

export function FilePicker({
  downloadAttachment,
  fileId,
  fileType,
  message = getText('Choose a file or drag it here'),
  name,
  onChange,
  onError,
  'data-qa-id': qaId,
  hideRemove,
  isRequired = false,
  'aria-label': ariaLabel,
  large,
  showDate,
  accept,
  disabled,
  extraAnalyticsData,
  maxSize,
  header,
  ...props
}: FilePickerProps) {
  const helpText = maxSize
    ? sprintf(getText('No file chosen (maximum size: %(maxSize)s MB)'), {
        maxSize,
      })
    : getText('No file chosen');

  return (
    <S3Picker
      downloadAttachment={downloadAttachment}
      isRequired={isRequired}
      fileId={fileId}
      fileType={fileType}
      name={name}
      onChange={onChange}
      onError={onError}
      qaId={qaId}
      aria-label={ariaLabel}
      accept={accept}
      disabled={disabled}
      extraAnalyticsData={extraAnalyticsData}
      maxSize={maxSize}
    >
      {({ onClick, filename, created, loading, dragActive, mouseActive }) => (
        <DropContainer
          position="relative"
          display="inline-flex"
          width={1}
          flexWrap="wrap"
          alignItems="center"
          pointerEvents="none"
          $dragActive={dragActive}
          $mouseActive={mouseActive}
          $large={large}
        >
          {large ? (
            <HoverOverlayLarge $mouseActive={mouseActive} $loading={loading} />
          ) : (
            <HoverOverlaySmall $mouseActive={mouseActive} $loading={loading} />
          )}

          {large ? (
            <ContentLarge
              onClick={onClick}
              fileId={fileId}
              filename={filename}
              qaId={qaId}
              hideRemove={hideRemove}
              onChange={onChange}
              loading={loading}
              showDate={showDate}
              downloadAttachment={downloadAttachment}
              disabled={disabled}
              created={created}
              message={message}
              header={header}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          ) : null}

          {!large ? (
            <ContentSmall
              onClick={onClick}
              fileId={fileId}
              filename={filename}
              qaId={qaId}
              hideRemove={hideRemove}
              onChange={onChange}
              loading={loading}
              showDate={showDate}
              downloadAttachment={downloadAttachment}
              disabled={disabled}
              created={created}
              message={message}
              helpText={helpText}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...props}
            />
          ) : null}
        </DropContainer>
      )}
    </S3Picker>
  );
}
